import classNames from 'classnames'
import { PureComponent } from 'react'

type Props = { value: number; className?: string }

export class ProgressBar extends PureComponent<Props> {
    render() {
        const { value, className } = this.props
        return (
            <div className={classNames('w-full bg-gray-200 rounded-full dark:bg-gray-700', className)}>
                <div
                    className="bg-blue-500 text-xl font-medium text-blue-100 text-center py-2 leading-none rounded-full ease-in-out duration-500"
                    style={{ width: `${value}%` }}
                >
                    {value.toFixed(2)}%
                </div>
            </div>
        )
    }
}
